import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppleMailLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "svg2",
		clipPath: "url(#clip0_2763_43577)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "layer1",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "g3062",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "rect2996",
					d: "M3.68673 0.0263672H12.3148C14.3421 0.0263672 15.9742 1.65844 15.9742 3.68574V12.3138C15.9742 14.3411 14.3421 15.9732 12.3148 15.9732H3.68673C1.65943 15.9732 0.0273438 14.3411 0.0273438 12.3138V3.68574C0.0273438 1.65844 1.65943 0.0263672 3.68673 0.0263672Z",
					fill: "url(#paint0_linear_2763_43577)"
				}), /* @__PURE__ */ _jsx("path", {
					id: "rect3027",
					d: "M3.5206 4.56152C3.43658 4.56152 3.35743 4.57602 3.28251 4.60582L4.78306 6.15067L6.30023 7.72321L6.32791 7.75643L6.37221 7.80073L6.41651 7.84502L6.5051 7.93915L7.80632 9.27359C7.82798 9.28706 7.89077 9.34522 7.93982 9.36974C8.003 9.40132 8.07148 9.43042 8.14207 9.43295C8.21825 9.43568 8.29611 9.41385 8.36465 9.38051C8.41599 9.35553 8.43882 9.31974 8.49846 9.27359L10.0045 7.71767L11.5272 6.15067L12.9946 4.63904C12.9004 4.588 12.796 4.56152 12.6845 4.56152H3.5206ZM3.06102 4.74978C2.901 4.90141 2.80078 5.12935 2.80078 5.38655V10.4585C2.80078 10.6668 2.86767 10.856 2.97797 11.0012L3.18838 10.8018L4.75538 9.27913L6.14519 7.93362L6.1175 7.90039L4.5948 6.3334L3.0721 4.76086L3.06102 4.74978ZM13.1939 4.79962L11.71 6.3334L10.1928 7.90039L10.1651 7.92808L11.6103 9.32897L13.1773 10.8517L13.2714 10.9403C13.3558 10.8049 13.4043 10.6381 13.4043 10.4585V5.38655C13.4043 5.15722 13.3249 4.94926 13.1939 4.79962ZM6.32238 8.11634L4.9381 9.46186L3.36557 10.9846L3.16623 11.1784C3.27132 11.246 3.39091 11.2891 3.5206 11.2891H12.6845C12.8404 11.2891 12.9818 11.2291 13.0998 11.1341L13.0001 11.0344L11.4276 9.51169L9.9824 8.11634L8.68118 9.45632C8.61075 9.50301 8.56369 9.55479 8.49493 9.58659C8.38425 9.63777 8.26296 9.68107 8.14104 9.6792C8.01879 9.67732 7.89893 9.62948 7.78922 9.57552C7.73415 9.54843 7.7048 9.52151 7.64021 9.46739L6.32238 8.11634Z",
					fill: "white"
				})]
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_2763_43577",
		x1: 8.11242,
		y1: 15.9092,
		x2: 8.12794,
		y2: .218883,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#70EFFF" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#5770FF"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2763_43577",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	})] })]
});
export { SvgAppleMailLogo as ReactComponent };
